import { useEffect, useRef } from "react";
import { useSettingsStore } from "@/stores/settingsStore";
import { useChartStore } from "@/stores/chartStore";
import { loadAndCommitCsvSymbol } from "./useCsvImport";

/** On mount, restores the last active CSV import from IndexedDB. */
export function useCsvRestore() {
  const doneRef = useRef(false);

  useEffect(() => {
    if (doneRef.current) return;
    doneRef.current = true;

    const { lastActiveCsvHash, customCsvSymbols, defaultSymbol } =
      useSettingsStore.getState();
    if (!lastActiveCsvHash) return;

    const meta = customCsvSymbols.find((s) => s.contentHash === lastActiveCsvHash);
    if (!meta) {
      useSettingsStore.getState().setLastActiveCsvHash(null);
      return;
    }

    loadAndCommitCsvSymbol(meta)
      .then((ok) => {
        if (!ok) {
          useSettingsStore.getState().removeCustomCsvSymbol(meta.contentHash);
          useSettingsStore.getState().setLastActiveCsvHash(null);
          useChartStore.getState().setSymbol(defaultSymbol);
        }
      })
      .catch(() => {
        useSettingsStore.getState().setLastActiveCsvHash(null);
        useChartStore.getState().setSymbol(defaultSymbol);
      });
  }, []);
}
